/**
 * Preferencias del jugador que se recuerdan entre partidas (en este dispositivo):
 *   camera      quiere jugar con la cámara (se vuelve a activar sola si el permiso sigue concedido)
 *   preview     mostrar la miniatura de la cámara con el esqueleto durante la partida
 *   difficulty  'normal' | 'soft'
 *   cameraRuns  partidas jugadas con la cámara (para los consejos de las primeras)
 *   gestureProfile  tus gestos medidos en la calibración (amplitud y velocidad), o null
 */
const KEY = 'dopamine-runner.settings.v1';
const DEFAULTS = { camera: false, preview: true, difficulty: 'normal', cameraRuns: 0, gestureProfile: null };

export class Settings {
  constructor(storage = globalThis.localStorage) {
    this.storage = storage;
    let saved = {};
    try {
      saved = JSON.parse(storage?.getItem(KEY) ?? '{}') ?? {};
    } catch {}
    Object.assign(this, DEFAULTS, saved);
  }

  set(changes) {
    Object.assign(this, changes);
    try {
      const data = Object.fromEntries(Object.keys(DEFAULTS).map((k) => [k, this[k]]));
      this.storage?.setItem(KEY, JSON.stringify(data));
    } catch {}
  }
}
